import React, { useState } from 'react';
import { realizations } from '../mock';
import { ArrowRight, Images } from 'lucide-react';
import Lightbox from './Lightbox';

const Realizations = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const openLightbox = (i) => setActiveIndex(i);
  const closeLightbox = () => setActiveIndex(null);

  return (
    <section id="realizacje" className="bg-[#f3f3f1]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16">
        <div className="flex items-center gap-3 mb-9">
          <span className="block w-7 h-[2px] bg-[#e30613]" />
          <h3 className="font-bold tracking-[0.22em] text-[13px] text-[#1c1c1c]">REALIZACJE</h3>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {realizations.map((r, idx) => {
            const cover = (r.images && r.images[0]) || r.img;
            const count = r.images ? r.images.length : 1;
            return (
              <button
                key={r.title}
                type="button"
                onClick={() => openLightbox(idx)}
                className="group bg-white shadow-sm hover:shadow-xl transition-all duration-300 overflow-hidden cursor-pointer text-left focus:outline-none focus:ring-2 focus:ring-[#e30613]/40"
              >
                <div className="relative h-[200px] overflow-hidden">
                  <img src={cover} alt={r.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                  {count > 1 && (
                    <span className="absolute top-3 right-3 inline-flex items-center gap-1 bg-black/65 backdrop-blur-sm text-white text-[10.5px] tracking-[0.12em] font-semibold px-2 py-1">
                      <Images size={12} />
                      {count}
                    </span>
                  )}
                </div>
                <div className="p-5">
                  <h4 className="font-bold text-[13px] tracking-[0.1em] text-[#1c1c1c]">{r.title}</h4>
                  <p className="text-[12.5px] text-[#666] mt-1">{r.subtitle}</p>
                  <div className="mt-4 space-y-1.5 text-[12px] text-[#3a3a3a]">
                    <p><span className="text-[#888]">System:</span> {r.system}</p>
                    <p><span className="text-[#888]">Metraż:</span> {r.area}</p>
                    <p className="text-[11.5px] text-[#666] pt-1">{r.detail}</p>
                  </div>
                  <div className="mt-4 pt-3 border-t border-black/5 flex items-center justify-between">
                    <span className="text-[11px] tracking-[0.18em] text-[#888] group-hover:text-[#e30613] transition-colors duration-200">ZOBACZ</span>
                    <ArrowRight size={14} className="text-[#e30613] group-hover:translate-x-1 transition-transform duration-200" />
                  </div>
                </div>
              </button>
            );
          })}
        </div>
      </div>

      <Lightbox
        open={activeIndex !== null}
        onClose={closeLightbox}
        images={activeIndex !== null ? (realizations[activeIndex].images || [realizations[activeIndex].img]) : []}
        title={activeIndex !== null ? realizations[activeIndex].title : ''}
        subtitle={activeIndex !== null ? realizations[activeIndex].subtitle : ''}
      />
    </section>
  );
};

export default Realizations;
